import React from 'react'
import { useOnboardingStore } from '../../stores/onboardingStore'
import { IndustrySelectionScreen } from './screens/IndustrySelectionScreen'
import { BusinessProfileScreen } from './screens/BusinessProfileScreen'
import { RevenueIntelligenceScreen } from './screens/RevenueIntelligenceScreen'
import { SupplyChainIntelligenceScreen } from './screens/SupplyChainIntelligenceScreen'
import { CompetitiveIntelligenceScreen } from './screens/CompetitiveIntelligenceScreen'
import { ServiceSelectionScreen } from './screens/ServiceSelectionScreen'
import { PaymentScreen } from './screens/PaymentScreen'
import { OnboardingLayout } from './components/OnboardingLayout'
import { IntelligenceProfileSummaryScreen } from './screens/IntelligenceProfileSummaryScreen'
import { IntelligenceDeliveryScreen } from './screens/IntelligenceDeliveryScreen'

export const OnboardingFlow: React.FC = () => {
  const { currentScreen } = useOnboardingStore()

  const renderCurrentScreen = () => {
    switch (currentScreen) {
      case 'industry-selection':
        return <IndustrySelectionScreen />
      case 'business-profile':
        return <BusinessProfileScreen />
      case 'revenue-intelligence':
        return <RevenueIntelligenceScreen />
      case 'supply-chain-intelligence':
        return <SupplyChainIntelligenceScreen />
      case 'competitive-intelligence':
        return <CompetitiveIntelligenceScreen />
      case 'service-selection':
        return <ServiceSelectionScreen />
      case 'intelligence-delivery':
        return <IntelligenceDeliveryScreen />
      case 'payment-activation':
        return <PaymentScreen />        
      case 'intelligence-summary':  
        return <IntelligenceProfileSummaryScreen />        
      default:
        return <IndustrySelectionScreen />
    }
  }

  return (
    <OnboardingLayout>
      {renderCurrentScreen()}
    </OnboardingLayout>
  )
}